import { useState } from "react";

interface FallbackImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
}

export const FallbackImage = ({ fallback, alt, ...props }: FallbackImageProps) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <>{fallback ?? <div className="img-fallback">{alt}</div>}</>;
  }

  return <img alt={alt} {...props} onError={() => setFailed(true)} />;
};